import http from '../_http'

const group = {
  //default
  summaryGroup: (m) => { return http.get(`manager/billing/invoice/group`, m); },
  listGroup: (m) => { return http.post(`manager/billing/invoice/group/list`, m); },
  detailGroup: (m) => { return http.get(`manager/billing/invoice/group/${m.id}`); },


  //crud
  insertGroup: (m) => { return http.post(`manager/billing/invoice/group`, m); },
  updateGroup: (m) => { return http.put(`manager/billing/invoice/group`, m); },
  deleteGroup: (m) => { return http.delete(`manager/billing/invoice/group/${m.id}`); },

  //credit
  //import partner Site
  pgGroup: (m) => { return http.post(`manager/billing/invoice/group/pg`, m); }, //credit
  creditGroup: (m) => { return http.post(`manager/billing/invoice/group/credit`, m); }, //point

  //ticket
  ticketGroup: (m) => { return http.post(`manager/billing/invoice/group/ticket`, m); },
}

export default group